import React from 'react'
import IconFont from "@components/IconFont";

const HoverIcon = (props) => {
    return (
        <div className="link" style={{cursor: 'pointer'}}>
            <IconFont
                type={props.inactiveIcon}
                className="hover-hide"
                style={{ fontSize: props.fontSize||"32px",color:props.color || null }}/>
            <IconFont type={props.activeIcon}
                      className="hover-show"
                      style={{ fontSize: props.fontSize||"32px",color:props.color || null }}/>
        </div>
    )
}

export default HoverIcon
